export const orderByOptions = [
  {
    name: '_%precio%_',
    code: 'price'
  },
  {
    name: '_%proximidad%_',
    code: 'proximity'
  },
  {
    name: '_%nombre%_',
    code: 'name'
  },
  {
    name: '_%estrellas%_',
    code: 'stars'
  }
];

export const getOrderByOptionName = type => {
  const option = orderByOptions.find(option => option.code === type);
  return option.name;
};
